$('.footer-mobile-list-header').click(function (e) {

  if ($(this).parent().hasClass("footer-mobile-list-active")) {
    $(this).parent().removeClass('footer-mobile-list-active');
  } else {
    $('.footer-mobile-list').removeClass('footer-mobile-list-active');
    $(this).parent().addClass('footer-mobile-list-active');
  }
  e.preventDefault();

});

$(document).ready(function(){
  // 监听滚动事件
  var viewportHeight = $(window).height();
  viewportHeight = viewportHeight * 1.5;
  
  $(window).scroll(function(){
    // 当向下滚动超过viewportHeight时显示按钮
    if ($(this).scrollTop() > viewportHeight) {
      $('#back-to-top').fadeIn();
    } else {
      $('#back-to-top').fadeOut();
    }
  });
  
  // 点击按钮返回顶部
  $('#back-to-top').click(function(){
    $('body,html').animate({scrollTop:0}, 300);
  });
});
